/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Workflow32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <rect width={28} height={28} x={2} y={2} fill={vars.bdlOrange} fillRule="nonzero" rx={4} />
            <path
                fill={vars.white}
                d="M21 19a2 2 0 11.001 3.999A2 2 0 0121 19zM19.5 9a3.5 3.5 0 110 7H13a2 2 0 100 4h3a1 1 0 010 2h-3c-2.21 0-4-1.79-4-4s1.79-4 4-4h6.5a1.5 1.5 0 001.493-1.356L21 12.5a1.5 1.5 0 00-1.5-1.5H14a1 1 0 010-2zM10 9a1 1 0 110 2 1 1 0 010-2z"
            />
        </g>
    </AccessibleSVG>
);

export default Workflow32;
